import { react2panel } from 'common/util/react2panel';
import { ChartLegendReact } from './index';
export const ChartLegendEl = react2panel("mp-chart-legend", ChartLegendReact, {
  contexts: ["segmentFilterController"]
});